// extracted by mini-css-extract-plugin
export var fadePop = "LoadingSpinner-module--fade-pop--35f70";
export var growHeightIn = "LoadingSpinner-module--grow-height-in--2c84b";
export var spinner = "LoadingSpinner-module--spinner--c5392";
export var spinner1 = "LoadingSpinner-module--spinner1--483bf";
export var spinner2 = "LoadingSpinner-module--spinner2--7ac5f";
export var spinner3 = "LoadingSpinner-module--spinner3--c10ee";